export const LOADER_HOLIDAYS             =    'LOADER_HOLIDAYS';
export const GET_HOLIDAYS                =    'GET_HOLIDAYS';
export const HOLIDAYS_FAIL               =    'HOLIDAYS_FAIL';
export const SAVE_LOADER_HOLIDAYS        =    'SAVE_LOADER_HOLIDAYS';
export const FORM_HOLIDAYS_FAIL          =    'FORM_HOLIDAYS_FAIL';

